var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Loader } from "../Loader";
var Img = /** @class */ (function (_super) {
    __extends(Img, _super);
    function Img(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isLoading: true,
            imgStyle: {}
        };
        return _this;
    }
    Img.prototype.loadImg = function () {
        var img = new Image();
        img.onload = this.onLoad.bind(this, img);
        img.onerror = this.onError.bind(this);
        img.src = this.props.src;
        return img;
    };
    Img.prototype.getValue = function (ref, fallback) {
        return ref || fallback;
    };
    Img.prototype.onLoad = function (img) {
        var imgWidth = this.getValue(this.props.width, img.width);
        var imgHeight = this.getValue(this.props.height, img.height);
        this.loadImgStyle(imgWidth, imgHeight, this.props.src);
        this.changeLoading(false);
    };
    Img.prototype.onError = function () {
        this.loadImgStyle(this.props.width, this.props.height, this.props.fallbackSrc);
        this.changeLoading(false);
    };
    Img.prototype.loadImgStyle = function (width, height, imgUrl) {
        this.setState({
            imgStyle: {
                width: width,
                height: height,
                backgroundImage: "url(\"" + imgUrl + "\")",
            }
        });
    };
    Img.prototype.changeLoading = function (state) {
        this.setState({ isLoading: state });
    };
    Img.prototype.componentDidMount = function () { this.loadImg(); };
    Img.prototype.render = function () {
        return (React.createElement("sb-img", { className: this.props.className, style: this.state.imgStyle }, this.state.isLoading && React.createElement(Loader, null)));
    };
    return Img;
}(React.Component));
export { Img };
//# sourceMappingURL=Img.js.map